import { Layout } from "./layout"
import { useEffect, useState } from "react";
import { useRoles } from '../systems/RolesContext';
import { Auth, Hub } from "aws-amplify";

import SAPAuthorizationFailed from "@dyl/components/SAPLoginError/SAPAuthorizationFailed";

const federatedIdName = 'MyCambridge';

const {
  REACT_APP_OIDC_REDIRECT_URI,
  REACT_APP_ENV_SAP_URL,
  REACT_APP_OIDC_CLIENT_ID,
} = process.env;

const OIDCAuthCheck = () => {
  const isAuthorizedLocalStorage = localStorage.getItem('isAuthorized');

  const [token, setToken] = useState(undefined);
  const [isAuthorized, setIsAuthorized] = useState(undefined);
  const { setRoleNames } = useRoles();

  const {
    pathname
  } = window.location;

  useEffect(() => {
    if (pathname === '/logout') {
      const url = `${REACT_APP_ENV_SAP_URL}/logout?redirect_uri=${REACT_APP_OIDC_REDIRECT_URI}&client_id=${REACT_APP_OIDC_CLIENT_ID}`
      window.location.href = url;
    } else {
      Hub.listen("auth", async ({ payload: { event, data }}) => {
        switch (event) {
          case "signIn":
          case "cognitoHostedUI":
            setToken("grating...");
            await getToken((userToken) => {
              setIsAuthorized(true);
              setToken(userToken?.idToken?.jwtToken || null);
            });
            break;
          case "signOut":
            setIsAuthorized(undefined);
            // setToken(null);
            setToken(undefined);
            localStorage.removeItem('isAuthorized');
            break;
          case "signIn_failure":
          case "cognitoHostedUI_failure":
            console.log("Sign in failure", data);
            localStorage.setItem("isAuthorized", false);
            setIsAuthorized(false);
            break;
          default:
            break;
        }
      });
    }
  }, []);

  useEffect(() => {
    if (pathname !== '/logout') {
      (async function() {
        await getToken((userToken) => {
          setToken(userToken?.idToken?.jwtToken || null);
        });
      })();
    }
  }, []);

  async function getToken(callback) {
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const currentSession = await Auth.currentSession();
      const decodedRoles = JSON.parse(decodeURIComponent(cognitoUser.attributes['custom:sap_roles']));
      const roleCollection = decodedRoles.flatMap((role)=> role.roleNames);
      setRoleNames(roleCollection);

      cognitoUser.refreshSession(currentSession.refreshToken, (err, session) => {
        callback(session);
      });
    } catch (e) {
      console.log('Unable to refresh Token', e);
      callback();
    }
  }

  if (token === undefined || pathname === '/logout') {
    return null;
  } else if (isAuthorizedLocalStorage === 'false' || isAuthorized === false) {
    return <SAPAuthorizationFailed />
  } else if (token === null) {
    Auth.federatedSignIn({ provider: federatedIdName });
    return null;
  } else {
    return <Layout />;
  }
}

export default OIDCAuthCheck;